module.exports = __webpack_public_path__ + "img/silencio.4455e2b7.png";